/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import pullProducts from '../../helpers/products/pullProducts';
import * as utils from '../../shared/utils';

export const pullProduct = createAsyncThunk(
  'products/pullProduct',
  async ({ productId }, {
    extra: { Logger, Toast, sdk },
    getState, dispatch,
  }) => {
    const product = getState().products.items.find(({ _id }) => _id === productId);
    const showError = (error) => {
      Toast(
        'This product was deleted in your Shopify store. To keep your data up-to-date, please sync your entire product catalog.',
        {
          autoClose: false, type: 'error', onOk: () => pullProducts(dispatch), btnOkValue: 'Try again',
        },
      );
      Logger.error(new Error('Error pull product'), { error }, [
        'PullProductFailed',
        { errorMessage: 'Product pull failed on the backend.' },
      ]);
    };

    try {
      /** If last pull less than 1 min ago */
      if (product?.pulledAt && (Date.now() - product.pulledAt) < 60000) {
        return product;
      }

      const { data } = await sdk.products.pullOne(productId);
      return data;
    } catch (error) {
      const errorSubcode = utils.getDataFromResponceError(error, 'subcode');
      Logger.log('UI', 'ToastProductPullFailed');

      if (errorSubcode !== 'HasAttachingAssetsError') showError(error);
      if (errorSubcode === 'HasAttachingAssetsError' && !product.availableOptions) {
        /** Get product if it has no available options (not fetched yet) */
        try {
          const { data } = await sdk.products.getOne(productId);
          return data;
        } catch (fetchError) {
          showError(fetchError);
          throw fetchError;
        }
      }

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    pullProduct.pending,
    (state, { meta }) => {
      const { productId } = meta.arg;
      state.items = state.items.map((item) => {
        if (item._id === productId) {
          return {
            ...item,
            isLoading: true,
          };
        }
        return item;
      });
      state.error = null;
    },
  ).addCase(
    pullProduct.fulfilled,
    (state, { payload: product }) => {
      state.items = state.items.map((item) => {
        if (item._id === product._id) {
          return {
            ...item,
            ...product,
            pulledAt: Date.now(), // if product is not pulled, pulledAt will be set below
            isLoading: false,
          };
        }
        return item;
      });
    },
  ).addCase(
    pullProduct.rejected,
    (state, { error, meta }) => {
      const { productId } = meta.arg;
      state.items = state.items.map((item) => {
        if (item._id === productId) {
          return {
            ...item,
            isLoading: false,
          };
        }
        return item;
      });
      state.error = error;
    },
  );
};
